// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Image_imgContainer__1GjYu"};